import { FC } from 'react';
import { ModalComponent } from '.';

type Props = {
  isOpen: boolean;
  handleSave: () => void;
  handleCancel: () => void;
  warningMessage: string;
  eyebrowText?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
};

export const ConfirmationModal: FC<Props> = ({
  isOpen,
  handleSave,
  handleCancel,
  warningMessage,
  eyebrowText = 'Proceed with caution!',
  confirmButtonText = 'Proceed with change',
  cancelButtonText = 'Cancel',
}) => {
  return (
    <ModalComponent isOpen={isOpen} closeModal={handleCancel}>
      <span className="oath-eyebrow inkBlue">{eyebrowText}</span>
      <span className="oath-body inkBlue">{warningMessage}</span>
      <button type="button" className="btn-inkBlue btn btn-secondary" onClick={handleSave}>
        {confirmButtonText}
      </button>
      <button
        type="button"
        className="oath-bodysmall link-text inkBlue padding0"
        onClick={handleCancel}
      >
        {cancelButtonText}
      </button>
    </ModalComponent>
  );
};
